import { baseAPI } from '~shared/api/base-api';
import { type ExportFormat, KEYS } from '~shared/api/query-keys';

interface ReportingInactiveStudentsParams {
  // Optional "as of" date (yyyy-MM-dd) — adds as-of age columns and is used
  // as the reference date for minAge/maxAge filtering.
  ageAsOf?: string;
  minAge?: number;
  maxAge?: number;
  format?: ExportFormat;
}

export const reportingInactiveStudentsAPI = async ({
  ageAsOf,
  minAge,
  maxAge,
  format = KEYS.EXPORT_FORMAT.CSV,
}: ReportingInactiveStudentsParams) => {
  const response = await baseAPI.get<string>('reporting/inactive-students', {
    params: {
      ...(ageAsOf ? { ageAsOf } : {}),
      ...(minAge !== undefined ? { minAge } : {}),
      ...(maxAge !== undefined ? { maxAge } : {}),
      format,
    },
    responseType: 'text',
  });
  return response.data;
};
